import { Button, defaultUser, Instagram } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import './card-to-create-instagram-mediakit.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  user?: Instagram
}

export default ({ user }: Props) => {
  const navigate = useNavigate()
  const [t] = useTranslation('cardToCreateMediaKit')

  const handleClick = () => {
    navigate(`/mediakit/${user?.id}`)
  }

  return (
    <div className="card-to-create-instagram-mediakit">
      <div className="card-middle-media-kit">
        <div className="image-card-to-create-instagram-mediakit">
          <figure>
            <img
              onError={({ currentTarget }) => {
                currentTarget.src = defaultUser
              }}
              src={user?.picture}
              alt={user?.fullName}
              title={user?.fullName}
              className="img-fluid"
            />
          </figure>
          <span className="social-icon background-instagram">
            <i className="fa-brands fa-instagram"></i>
          </span>
        </div>
        <div className="text-card-to-create-instagram-mediakit">
          <h4>{user?.fullName}</h4>
          <p>{`@ ${user?.username}`}</p>
        </div>
      </div>
      <div className="button-card-to-create-instagram-mediakit">
        <Button onClick={() => handleClick()} width="100%" color="var(--black_light)" textColor="var(--white)" borderStyle="none" size="md">
          {t('button')}
        </Button>
      </div>
    </div>
  )
}
